module.exports = {"meta":{"lead":"Cloud services for groups"}};